//https://mixitup.kunkalabs.com/
// To keep our code clean and modular, all custom functionality will be contained inside a single object literal called "checkboxFilter".

var checkboxFilter = {

    // Declare any variables we will need as properties of the object

    $filters: null,
    $types: null,
    //$reset: null,
    groups: [],
    outputArray: [],
    outputString: '',
    $activeType: null,

    // The "init" method will run on document ready and cache any jQuery objects we will need.

    init: function () {
        var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "checkboxFilter" object so that we can share methods and properties between all parts of the object.

        self.$filters = $('#Filters');
        self.$types = $('#Types');
        //self.$reset = $('#Reset');
        self.$container = $('#productsContainer');

        self.$filters.find('fieldset').each(function () {
            self.groups.push({
                $inputs: $(this).find('input'),
                active: [],
                tracker: false
            });
        });

        self.$filters.find('fieldset > p.filter-heading').click(function (e) {
            var active = $(e.target).closest('fieldset').hasClass('active');

            self.$filters.find('fieldset').removeClass('active');
            if (!active)
                $(e.target).closest('fieldset').addClass('active');
        });

        self.bindHandlers();

        // Look for possibly pre-set filters
        if (self.$types.find('.type').length > 0) {
            if (self.$filters.find('#type').find('input[type=checkbox]').is(':checked') == false) {
                //alleen als er geen type is geselecteerd de eerste selecteren. Bij backbutton vanaf detail blijft de selectie dan bewaard.
                self.$filters.find('#type').find('#' + self.$types.find('.type')[0].id.replace('tab-','')).prop('checked', true);
            }
        }

        var hash = window.location.hash.replace(/^#/g, '');
        hash = replaceAll(hash, '%20active', '');
        if (hash.length > 0) {
            for (var i = 0, item; item = hash.split('&')[i]; i++) {
                try {
                    var key = item.split('=')[0].toLowerCase();
                    var value = item.split('=')[1].toLowerCase();
                    self.$filters.find('.filter-' + key).find(escape('.option-' + value)).prop('checked', true);
                } catch (e) {
                    //just skip this filter. Probably filter renamed
                }
            }
        }

        self.parseFilters();

        if (self.outputString.length > 0)
            return self.outputString;

        return 'all';
    },

    // The "bindHandlers" method will listen for whenever a form value changes.

    bindHandlers: function () {
        var self = this;

        self.$filters.on('change', function (e) {

            console.log("change");
           
            //bbq to distribute filters
            var hash = window.location.hash;

            var key = $(e.target).parents('fieldset')[0].className.replace('filter-', '');
            var value = '';
            for (var i = 0, item; item = e.target.className.split(' ')[i]; i++) {
                if (item.indexOf('option-') > -1) {
                    value = item.replace('option-', '');
                }
            }

            if ($(e.target).prop('checked') == true) {
                //append new filter to url
                if (hash.length == 0) {
                    hash = '#';
                } else {
                    hash += '&';
                }
                hash += key + '=' + value;

                //GA4
                trackEventGlobalAndLocalGA4({ 'ga4_name': 'filter', 'ga4_filter_action': 'check', 'ga4_model_category': window.ga_category,'ga4_click_text':value});
            } else {
                //remove filter from url
                hash = hash.replace('#' + key + '=' + value, '').replace('&' + key + '=' + value, '');
                if (hash.length > 0) {
                    hash = '#' + hash.substring(1, hash.length);
                }
                trackEventGlobalAndLocalGA4({ 'ga4_name': 'filter', 'ga4_filter_action': 'uncheck', 'ga4_model_category': window.ga_category, 'ga4_click_text': value });
            }
            if (window.formpost == false) {
                window.history.pushState(hash, hash, window.location.origin + window.location.pathname + window.location.search + hash);
            }
            self.parseFilters();
        });

        self.$types.find('.type').on('click', function () {
            $('.bike-filtering-vertical').show();
            $('.bike-filtering-vertical').removeClass("filterAnimation");
            var id = $(this).prop('id').replace('tab-','');
            self.$filters.find('input').prop('checked', false);
            self.$filters.find('#type').find('#' + id).prop('checked', true);
            self.parseFilters();
        });

        //self.$reset.on('click', function (e) {
        //    e.preventDefault();
        //    self.$filters[0].reset();
        //    self.parseFilters();
        //});
    },

    // The parseFilters method checks which filters are active in each group:

    parseFilters: function () {
        var self = this;

        // loop through each filter group and add active filters to arrays

        for (var i = 0, group; group = self.groups[i]; i++) {
            group.active = []; // reset arrays
            group.$inputs.each(function () {
                $(this).is(':checked') && group.active.push(this.value);
            });
            group.active.length && (group.tracker = 0);
        }

        self.concatenate();
        $activeType = Enumerable.From(checkboxFilter.groups).Where(function (x) { return x.active.length > 0 && x.$inputs.parents('fieldset')[0].id == 'type' }).FirstOrDefault();
        if ($activeType != undefined) {
            $('#Types').find('button').removeClass('active');
            $('#Types').find('button').attr('tabindex', '-1');
            $('#Types').find('button').attr('aria-selected', false);
            $('#Types').find('#tab-' + $activeType.active[0].replace('.', '')).find('button').addClass('active');
            $('#Types').find('#tab-' + $activeType.active[0].replace('.', '')).find('button').attr('tabindex', '0');
            $('#Types').find('#tab-' + $activeType.active[0].replace('.', '')).find('button').attr('aria-selected', true);
            $('#productsContainer').attr('aria-labelledby', $activeType.active[0].substring(1, $activeType.active[0].length));
        }

        //$('#productsContainer .row-container').hide();
        //$('#productsContainer .row-container').find($activeType.active[0]).parents('.row-container').show();
    },

    // The "concatenate" method will crawl through each group, concatenating filters as desired:

    concatenate: function () {
        var self = this,
            cache = '',
            crawled = false,
            checkTrackers = function () {
                var done = 0;

                for (var i = 0, group; group = self.groups[i]; i++) {
                    (group.tracker === false) && done++;
                }

                return (done < self.groups.length);
            },
            crawl = function () {
                for (var i = 0, group; group = self.groups[i]; i++) {
                    group.active[group.tracker] && (cache += group.active[group.tracker]);

                    if (i === self.groups.length - 1) {
                        self.outputArray.push(cache);
                        cache = '';
                        updateTrackers();
                    }
                }
            },
            updateTrackers = function () {
                for (var i = self.groups.length - 1; i > -1; i--) {
                    var group = self.groups[i];

                    if (group.active[group.tracker + 1]) {
                        group.tracker++;
                        break;
                    } else if (i > 0) {
                        group.tracker && (group.tracker = 0);
                    } else {
                        crawled = true;
                    }
                }
            };

        self.outputArray = []; // reset output array

        do {
            crawl();
        }
        while (!crawled && checkTrackers());

        self.outputString = self.outputArray.join();

        // If the output string is empty, show all rather than none:

        !self.outputString.length && (self.outputString = 'all');

        //log(self.outputString);

        // ^ we can check the console here to take a look at the filter string that is produced

        // Send the output string to MixItUp via the 'filter' method:

        if (self.$container.mixItUp('isLoaded')) {
            self.$container.mixItUp('filter', self.outputString);
        } else {

        }
    }
};

// On document ready, initialise our code.

$(function () {

    var sortOrder = 'pricemax:desc';

    //$('#toggle-sort-container').each(function () {
    //    if ($('.mix[data-pricemin = 0]').length == 0) {
    //        $(this).show();
    //    }
    //});

    $('.toggle-sort').on('change', function (e, f) {
        switch ($(this).val()) {
            case 'pricemin:asc':
                sortOrder = 'pricemin:asc';
                break;
            case 'pricemax:desc':
                sortOrder = 'pricemax:desc';
                break;
            case 'distancepickup:asc':
                sortOrder = 'distancepickup:asc distancestock:asc';
                break;
            case 'distancestock:asc':
                sortOrder = 'distancestock:asc distancepickup:asc';
                break;
        }

        $('#productsContainer').mixItUp('sort', sortOrder);
    });

    //Special sorting for stock filter selection
    //$('#stock .regular-checkbox').on('change', function () {
    //    if ($('.option-in-store').is(':checked') && $('.option-in-warehouse').is(':checked') == false) {
    //        $('#toggle-sort-container #sortby').val('distancestock:asc');
    //        $('#toggle-sort-container #sortby').trigger('change');
    //    }else if ($('.option-in-warehouse').is(':checked')) {
    //        $('#toggle-sort-container #sortby').val('distancepickup:asc');
    //        $('#toggle-sort-container #sortby').trigger('change');
    //    }
    //});

    // Initialize checkboxFilter code
    if ($('#productsContainer').length > 0) {
        var preSetFilters = checkboxFilter.init();
    }


    // Instantiate MixItUp
    $('#productsContainer').mixItUp({
        controls: {
            enable: false // we won't be needing these
        },
        load: {
            filter: preSetFilters,
            sort: window.sortorderCatalogue
        },
        activeClass: 'on',
        animation: {
            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
            duration: 0,
            effects: 'scale'
        },
        callbacks: {
            onMixStart: function (state, futureState) {
                //log("onMixStart");
                //$('.image').hide();
            },
            onMixEnd: function (state) {

                $('.numberOfItemsFiltered').remove();
                $('.checkbox').removeClass('disabled');
                $('.checkbox input').removeAttr('disabled');
                var showFilters = false;

                $.each(state.$hide, function (item,x) {
                    $(x).hide();
                });

                if (state.totalHide > 0) {
                    $('.crosslinktile').hide();
                    $('.cataloguebannertile').hide();
                } else {
                    $('.crosslinktile').show();
                    $('.cataloguebannertile').show();
                }

                // refresh item count
                setItemCount();

                

                $.each(checkboxFilter.groups, function (g, group) {
                    $.each(group.$inputs, function (f, filter) {
                        var filterName = $(filter).attr('id');
                        var currentFilterGroupId = $('#Filters .checkbox input[id="' + filterName + '"]').parents('fieldset').attr('id');
                        var matchAnyFilters = [];
                        var matchAllFilters = [];
                        matchAllFilters.push(filterName);

                        $.each(checkboxFilter.outputArray, function (t, activeFilter) {
                            $.each(activeFilter.split('.'), function (z, item) {
                                if (item.length > 0) {
                                    var activeFilterGroupId = $('#Filters .checkbox input[id="' + item + '"]').parents('fieldset').attr('id');
                                    var activeFilterGroup = Enumerable.From(checkboxFilter.groups).Where(function (x) { return Enumerable.From(x.$inputs).Where(function (x) { return $(x).attr('id') == item }).Count() > 0 }).FirstOrDefault();
                                    var numberOfFiltersInSameGroup = activeFilterGroup.active.length;
                                    if (currentFilterGroupId == activeFilterGroupId) {
                                        if (matchAllFilters.indexOf(filterName) == -1) {
                                            matchAllFilters.push(filterName);
                                        }
                                    } else if (currentFilterGroupId != activeFilterGroupId && numberOfFiltersInSameGroup == 1) {
                                        if (matchAllFilters.indexOf(item) == -1) {
                                            matchAllFilters.push(item);
                                        }
                                    } else if (currentFilterGroupId != activeFilterGroupId && numberOfFiltersInSameGroup > 1) {
                                        if (matchAnyFilters.indexOf(item) == -1) {
                                            matchAnyFilters.push(item);
                                        }
                                    }
                                }
                            });
                        });

                        var i = Enumerable.From(state.$targets)
                            .Where(function (i) {
                                var allFiltersValidation = true, anyFiltersValidation = true;
                                if (matchAllFilters.length > 0) {
                                    allFiltersValidation = Enumerable.From(matchAllFilters).All(function (j) {
                                        return $(i)[0].classList.contains(j);
                                    });
                                }
                                if (matchAnyFilters.length > 0) {
                                    anyFiltersValidation = Enumerable.From(matchAnyFilters).Any(function (j) {
                                        return $(i)[0].classList.contains(j);
                                    });
                                }
                                return allFiltersValidation && anyFiltersValidation;
                            }).Select(function (x) {
                                return x
                            }).Count();

                        if (group.$inputs.length == 1 && i == state.$targets.length) {
                            //1 filter is geen filter
                            group.$inputs.parents('fieldset').hide();
                        }

                        if (i >= state.$targets.length) {
                            $(filter).parents('.checkbox').addClass('disabled');
                            $(filter).parents('.checkbox').hide();
                        } else if (i > 0) {
                            $(filter).parents('.checkbox').find('label span').append('<span class="numberOfItemsFiltered">(' + i + ')</span>');
                        } else {
                            $(filter).attr('disabled', 'disabled');
                            $(filter).parents('.checkbox').addClass('disabled');
                        }
                    });

                    //if (group.$inputs.context.id != 'type') {
                    if (group.$inputs.parents('fieldset')[0].id != 'type') {
                        if (Enumerable.From(group.$inputs.parent()).Where(function (x) { return $(x).hasClass('disabled') == false }).ToArray().length == 0) {
                            //all filterOptions disabled. Hide this filter
                            group.$inputs.parents('fieldset').hide();
                        } else {
                            group.$inputs.parents('fieldset').show();
                            showFilters = true;
                        }
                    }
                });
                if (showFilters == false) {
                    $('#bike-filtering-vertical-container').addClass("filterAnimation");

                    //hide sort dropdown
                    $('#toggle-sort-container').css('visibility', 'hidden');
                } else {
                    $('#bike-filtering-vertical-container').show(function () {
                        $('.bike-filtering-vertical').show();
                        $('#bike-filtering-vertical-container').removeClass("filterAnimation");
                        $('.bike-filtering-vertical').addClass("filterAnimation");
                    });

                    //check filter options to hide group if no option is there
                    //voor nu uitgezet, omdat op mobile de filters helemaal niet meer werden getoond. Moet wel werkend worden gemaakt, zie http://localhost:50890/us/bikes2/mountain-bikes/26-inch
                    //$('form#Filters fieldset').each(function () {
                    //    if ($(this).children('.checkbox:visible').length == 0) {
                    //        $(this).hide();
                    //    }
                    //});

                    if ($('form#Filters fieldset:visible').length == 0) {
                        $('#bike-filtering-vertical-container').addClass("filterAnimation");
                    }
                }

                //show / hide sort dropdown
                if ($('.product').is(":visible") && $('.mix[data-pricemin = 0]').is(":visible") == false) {
                    /*if ($('.mix[data-pricemin = 0]').length == 0) {*/
                    $('#toggle-sort-container').css('visibility', 'visible');
                } else {
                    $('#toggle-sort-container').css('visibility', 'hidden');
                }

                //Initiate Lazyloading images
                $.force_appear();

                //show count result
                $('#number-of-results span#countActiveRows').html($("#productsContainer .mix:visible").length);
                $('#number-of-results').show();

                if (state.activeFilter == ".mix") {
                    $("a#clearfilters").hide();
                } else {
                    $("a#clearfilters").show();
                }
             
                //diable sort order distance
                if ($('#sortby option[value="distancepickup:asc"]').length > 0) {
                    if ($("#productsContainer .mix:visible").length > 0 && $("#productsContainer .mix:visible .stock-limited").length > 0 && $("#productsContainer .mix:visible").length == $("#productsContainer .mix:visible .stock-limited").length) {
                        //when all visible items are local stock disable sort Distance closest store for pickup
                        $('#sortby option[value="distancepickup:asc"]').prop('disabled', true);

                        //sort order by distance in stock
                        //$('#toggle-sort-container #sortby').val('distancestock:asc');
                        //$('#toggle-sort-container #sortby').trigger('change');
                    } else {
                        $('#sortby option[value="distancepickup:asc"]').prop('disabled', false);

                        //sort order by distance pickup
                        //$('#toggle-sort-container #sortby').val('distancepickup:asc');
                        //$('#toggle-sort-container #sortby').trigger('change');
                    }
                }
            }
        }
    });

    $(document).keyup(
        function (e) {
            // Tab
            if (e.keyCode == 9) {
                // Define function to remove outline from checkbox.
                var removeOutline = function () {
                    var elements = document.getElementsByClassName('checkbox-outlined');
                    if (elements) {
                        for (var i = 0; i < elements.length; i++) {
                            var element = elements.item(i);
                            element.classList.remove('checkbox-outlined');
                        }
                    }
                }

                // Get current focussed element.
                var focussedElement = document.activeElement;

                // Only execute if we have a focussedElement
                if (focussedElement) {
                    // Remove outline from other element if present.
                    removeOutline();

                    // Check if the element is a MixItUp checkbox.
                    if (focussedElement.tagName.toLowerCase() == 'input'
                        && focussedElement.classList.contains('regular-checkbox')) {
                        // Find parent element of the checkbox and add outline class
                        var parentEl = focussedElement.parentElement;
                        parentEl.classList.add('checkbox-outlined');
                    }
                }
            }
        }
    )

    $(document).keydown(
        function (e) {
            var current = $('#Types').find('button.active');

            if (e.keyCode == 39) {
                var next = $('#Types').find('button.active').parent().next().find('button');
                next.focus();
                next.click();

            }
            if (e.keyCode == 37) {
                var prev = $('#Types').find('button.active').parent().prev().find('button');
                prev.focus();
                prev.click();
            }
            // Code below if for accessibility of the MixItUp component.
            // Spacebar. For check / uncheck of the MixItUp checkbox.
            if (e.keyCode == 32) {
                var focussedElement = document.activeElement;

                // Only execute if we have a focussedElement
                if (focussedElement) {
                    // Check if the element is a MixItUp checkbox.
                    if (focussedElement.tagName.toLowerCase() == 'input'
                        && focussedElement.classList.contains('regular-checkbox')) {
                        setTimeout(function() {
                            // Click it.
                            focussedElement.click();
                        });
                    }
                }
            }
        }
    );
});
